(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-requisition-consent', {
                parent: 'entity',
                url: '/lab-requisition-consent',
                data: {
                    pageTitle: 'Lab Requisition Consents'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-requisition-consent/list/lab-requisition-consent.html',
                        controller: 'LabRequisitionConsentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();
